import { ApiErrorResponse } from '../types/ApiErrorResponse';

export default class ApiHttpError extends Error {
  httpMessage: string;
  status: number;

  constructor(status: number, message: ApiErrorResponse) {
    super(message.message);
    this.httpMessage = message.httpMessage;
    this.status = status;
    Object.setPrototypeOf(this, ApiHttpError.prototype);
  }
}
